import type { FPSMeterProps } from "@overengineering/fps-meter"
import type { QueryClient } from "@tanstack/react-query"
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  Scripts,
} from "@tanstack/react-router"
import * as React from "react"
import type { AuthData } from "../../shared/auth.ts"
import type { Zero } from "../lib/zero.ts"

export const Route = createRootRouteWithContext<{
  authData: AuthData | null | undefined
  queryClient: QueryClient
  zero: Zero
}>()({
  component() {
    return (
      <>
        <HeadContent />
        <Outlet />
        <Scripts />
        <React.Suspense>
          <FPSMeter className="fixed end-2 top-14 bg-neutral-7" />
        </React.Suspense>
      </>
    )
  },
})

const FPSMeter: React.FC<FPSMeterProps> = import.meta.env.PROD
  ? () => null
  : React.lazy(() =>
      import("@overengineering/fps-meter").then((res) => ({
        default: res.FPSMeter,
      })),
    )
